const React = require("react");
function IconCb(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.10766 4.30005c-.88789 0-1.60766.74781-1.60766 1.67029V7.1637h21V5.97034c0-.92248-.7198-1.67029-1.6077-1.67029zM22.5 10.0273h-21v7.8752c0 .9225.71977 1.6703 1.60766 1.6703H20.8923c.8879 0 1.6077-.7478 1.6077-1.6703z"
  }));
}
module.exports = IconCb;